import {
    LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST,
    LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS,
    LOGBOOK_LOAD_REQUEST,
    LOGBOOK_LOAD_SUCCESS,
    LOGBOOK_LOAD_SUCCESS_NO_DATA
} from "../config/actions";

export const load = (lastUpdateCall) => ({
    type: LOGBOOK_LOAD_REQUEST,
    payload: {
        lastUpdateCall: lastUpdateCall
    }
});

export const load_success = (payload) => ({
    type: LOGBOOK_LOAD_SUCCESS,
    payload: payload
});

export const load_success_no_data = () => ({
    type: LOGBOOK_LOAD_SUCCESS_NO_DATA
});

export const load_available_assignees = () => ({
    type: LOGBOOK_AVAILABLE_ASSIGNEES_REQUEST
});

export const load_available_assignees_success = (payload) => ({
    type: LOGBOOK_AVAILABLE_ASSIGNEES_SUCCESS,
    payload: payload
});
